import React, { useState } from "react";
import styles from "./EnquiriesGraph.module.css";
import { FiEdit2 } from "react-icons/fi";

const tabOptions = ["Enquiry by source", "Total Conversions", "Deal Stage"];

const enquiryData = {
  "Enquiry by source": [
    { category: "Health", total: 15, conversions: 10 },
    { category: "Admissions", total: 16, conversions: 15 },
    { category: "Complaints", total: 30, conversions: 18 },
  ],
  "Total Conversions": [
    { category: "Health", total: 12, conversions: 6 },
    { category: "Admissions", total: 22, conversions: 14 },
    { category: "Complaints", total: 16, conversions: 10 },
  ],
  "Deal Stage": [
    { category: "Inquiry", total: 10, conversions: 3 },
    { category: "Follow-up", total: 20, conversions: 9 },
    { category: "Closed", total: 30, conversions: 25 },
  ],
};

const EnquiriesGraph = () => {
  const [activeTab, setActiveTab] = useState("Enquiry by source");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleEditClick = () => {
    console.log("This Month clicked");
  };
  

  const data = enquiryData[activeTab];

  return (
    <div className={styles.container}>
      <div className={styles.tabHeaderRow}>
        <div className={styles.tabSelector}>
          {tabOptions.map((tab, i) => (
            <div
              key={i}
              className={`${styles.tabItem} ${
                activeTab === tab ? styles.activeTab : ""
              }`}
              onClick={() => handleTabClick(tab)}
            >
              {tab}
            </div>
          ))}
        </div>

        <div className={styles.editWrapper} onClick={handleEditClick}>
          <FiEdit2 size={16} />
          <span>This Month</span>
        </div>
      </div>

      <div className={styles.chart}>
        {data.map((item, i) => {
          const height = (item.conversions / item.total) * 100;
          return (
            <div className={styles.barContainer} key={i}>
              <div className={styles.totalLabel}>{item.total}</div>
              <div className={styles.barWrapper}>
                <div className={styles.totalBar}>
                  <div
                    className={styles.installedBar}
                    style={{ height: `${height}%` }}
                  >
                    {item.conversions}
                  </div>
                </div>
              </div>
              <div className={styles.categoryLabel}>{item.category}</div>
            </div>
          );
        })}
      </div>

      <div className={styles.legend}>
        <div className={styles.dotRow}>
          <span className={styles.lightDot}></span>
          <span>Total enquiries</span>
        </div>
        <div className={styles.dotRow}>
          <span className={styles.solidDot}></span>
          <span>Conversions</span>
        </div>
      </div>
    </div>
  );
};

export default EnquiriesGraph;
